import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { lastFiveDigitsComparator, titleCase } from '../../common/commonFunction';
import { Button } from '@mui/material';
import { PROD } from '../../common/constants';
import {
    Container,
    Stack,
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Radio,
    RadioGroup,
    FormControlLabel
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import { getAllState, getAllDistrict, getAllRevenueCircle, growersDbsList, addGrowersDbs } from './resourceCommonAPIs';
import { STATE, DISTRICT, REVENUE_CIRCLE, PROCEED } from '../../common/constants';
import BackButton from '../../common/backButton';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { toast } from 'react-toastify';

function Dbs() {
    const navigate = useNavigate();

    const [chooseState, setchooseState] = useState([]);
    const [chooseDistrict, setChooseDistrict] = useState([]);
    const [chooseRevenueCircle, setChooseRevenueCircle] = useState([]);
    const [proceed, setProceed] = useState(false);
    const [details, setDetails] = useState({
        state: "",
        district: "",
        revenueCircle: "",
        hitMapped: ""
    });
    const [errorMessage, setErrorMessage] = useState({
        stateError: '',
        districtError: '',
        hitMappedError: ''
    });
    const [growersList, setGrowersList] = useState([]);
    const [growersListOld, setGrowersListOld] = useState([]);
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [dbsFlag, setDbsFlag] = useState("");
    const [response, setResponse] = useState();

    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);

    useEffect(() => {
        getAllState(setchooseState);
    }, []);

    const handleChange = (e) => {
        if (e.target.name === "state") {
            getAllDistrict(e.target.value, setChooseDistrict);
            setChooseRevenueCircle([]);
            setDetails({ ...details, state: e.target.value, district: "", revenueCircle: "" });
            setErrorMessage({ ...errorMessage, stateError: "" });
        }
        if (e.target.name === "district") {
            getAllRevenueCircle(e.target.value, setChooseRevenueCircle);
            setDetails({ ...details, district: e.target.value, revenueCircle: "" });
            setErrorMessage({ ...errorMessage, districtError: "" });
        }
        if (e.target.name === "revenueCircle") {
            setDetails({ ...details, revenueCircle: e.target.value });
        }
        if (e.target.name === "hitMapped") {
            setDetails({ ...details, hitMapped: e.target.value });
            setErrorMessage({ ...errorMessage, hitMappedError: "" });
        }
    };

    const onProceed = () => {
        setProceed(true);
        setSelectedRows([]);
        setDbsFlag("");

        if (!details.state) {
            setErrorMessage({ ...errorMessage, stateError: "Please enter state" });
        } else if (!details.district) {
            setErrorMessage({ ...errorMessage, districtError: "Please enter district" });
        }
        else if (!details.hitMapped) {
            setErrorMessage({ ...errorMessage, hitMappedError: "Please select mapped with HIT" });
        } else {
            growersDbsList(details, setGrowersList, setGrowersListOld);
        }
    };

    useEffect(() => {
        if (response) {
            growersDbsList(details, setGrowersList, setGrowersListOld);
        }
    }, [response])

    const onSubmit = () => {
        if (!selectedRows || selectedRows.length === 0) {
            toast.error("Please select at least one row");
            return;
        }
        if (!dbsFlag) {
            toast.error("Please select DBS Yes/No");
            return;
        }
        handleLogModalOpen();
    };

    const onConfirmSubmit = () => {
        handleLogModalClose();

        const tempArr = growersList
            .filter((item) => selectedRows.includes(item.landId))
            .map((item) => ({
                category: "Grower",
                growerType: item.growerType,
                growerUrn: item.urn,
                landId: item.landId,
                dbsFlag: dbsFlag,
            }));

        addGrowersDbs(tempArr, setSelectedRows, setDbsFlag, setResponse);
    };

    const columns = [
        { field: 'name', headerName: "Grower Name", width: 250 },
        {
            field: 'urn',
            headerName: "URN",
            width: 220,
            sortComparator: (a, b) => lastFiveDigitsComparator(a, b)
        },
        { field: 'landName', headerName: "Land Name", width: 250 },
        { field: 'hitMapped', headerName: "HIT Mapped", width: 200 },
        {
            field: 'dbsFlag',
            headerName: "DBS",
            width: 130,
            renderCell: (params) => (
                <span>{params.value === "Y" ? "Yes" : "No"}</span>
            )
        }
    ];

    return (
        <Container maxWidth="xxl">
            {!PROD && <p className='pageNumberingResc'>RES05</p>}

            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <BackButton navigate={navigate} />
                <Typography variant="h5" gutterBottom>
                    Growers List
                </Typography>
            </Stack>

            <Card>
                <CardContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} lg={3}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={proceed && !details?.state}>
                                <InputLabel id="mappedstakeholder-label">{STATE}</InputLabel>
                                <Select
                                    label={STATE}
                                    name="state"
                                    value={details?.state || ''}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <MenuItem value=""><em>{STATE}</em></MenuItem>
                                    {chooseState?.map((statename, index) => (
                                        <MenuItem key={index} value={statename}>
                                            {statename && titleCase(statename)}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText sx={{ color: 'red' }}>{errorMessage?.stateError}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} lg={3}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={proceed && !details?.district}>
                                <InputLabel id="mappedstakeholder-label">{DISTRICT}</InputLabel>
                                <Select
                                    label={DISTRICT}
                                    name='district'
                                    value={details?.district || ''}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <MenuItem value=""><em>{DISTRICT}</em></MenuItem>
                                    {chooseDistrict?.map((districtname, index) => (
                                        <MenuItem key={index} value={districtname}>
                                            {districtname && titleCase(districtname)}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText sx={{ color: 'red' }}>{errorMessage?.districtError}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} lg={3}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                <InputLabel id="mappedstakeholder-label">{REVENUE_CIRCLE}</InputLabel>
                                <Select
                                    label={REVENUE_CIRCLE}
                                    name='revenueCircle'
                                    value={details?.revenueCircle || ''}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <MenuItem value=""><em>Select</em></MenuItem>
                                    {chooseRevenueCircle?.map((revenueCirclename, index) => (
                                        <MenuItem key={index} value={revenueCirclename}>
                                            {titleCase(revenueCirclename)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={proceed && !details?.hitMapped}>
                                <InputLabel id="mappedstakeholder-label">Mapped with HIT</InputLabel>
                                <Select
                                    label="Mapped with HIT"
                                    name="hitMapped"
                                    value={details?.hitMapped || ''}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <MenuItem value="Y">Yes</MenuItem>
                                    <MenuItem value="N">No</MenuItem>
                                </Select>
                                <FormHelperText sx={{ color: 'red' }}>{errorMessage?.hitMappedError}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6} lg={2} mt={1}>
                            <Button
                                sx={{ minWidth: 100 }}
                                variant="contained"
                                onClick={onProceed}
                            >
                                {PROCEED}
                            </Button>
                        </Grid>

                        {proceed && growersList?.length > 0 && (
                            <Grid item xs={12} lg={12} mt={2}>
                                <Box
                                    sx={{
                                        mb: 2,
                                        p: 2,
                                        border: '1px solid #e0e0e0',
                                        borderRadius: 1
                                    }}
                                >
                                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                        DBS Selection for Selected Rows
                                    </Typography>
                                    <RadioGroup
                                        row
                                        value={dbsFlag}
                                        onChange={(e) => setDbsFlag(e.target.value)}
                                    >
                                        <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="N" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </Box>

                                <DataGrid
                                    autoHeight
                                    rows={growersList}
                                    columns={columns}
                                    getRowId={(row) => row?.landId}
                                    // pageSize={5}
                                    // rowsPerPageOptions={[5, 10, 20]}
                                    checkboxSelection
                                    disableSelectionOnClick
                                    selectionModel={selectedRows}
                                    onSelectionModelChange={(newSelection) => setSelectedRows(newSelection)}
                                    components={{
                                        Toolbar: CustomDataGridToolbar,
                                    }}
                                    componentsProps={{
                                        toolbar: {
                                            rows: growersList,
                                            columns: columns,
                                            fileName: "GrowersList.xlsx"
                                        }
                                    }}
                                />
                            </Grid>
                        )}
                    </Grid>
                </CardContent>
            </Card>

            {proceed && growersList?.length > 0 && (
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button
                        sx={{ minWidth: 100, ml: 1 }}
                        variant="contained"
                        onClick={onSubmit}
                    >
                        Submit
                    </Button>
                </Box>
            )}

            <ConfirmationPopover
                onOpen={logModalOpen}
                onConfirm={onConfirmSubmit}
                onClose={handleLogModalClose}
                action="Submit"
            />
        </Container>
    );
}

export default Dbs;